import { render } from "./PaymentOrderView.vue?vue&type=template&id=c2a331f4"
import script from "./PaymentOrderView.vue?vue&type=script&lang=js"
export * from "./PaymentOrderView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__